export enum Query {
    AccountsCreation = "accountsCreation",
    AccountCreation = "accountCreation",
    AccountCreationFromToken = "accountCreationFromToken",
    Users = "users",
    User = "user",
    UserPreferences = "userPreferences",
    UserConfig = "userConfig",
    AuthMe = "authMe",
    CountryConfiguration = "countryConfiguration",
    Organizations = "organizations",
    OrganizationsWithSfInfos = "organizationsWithSfInfos",
    Organization = "organization",
    OrganizationService = "organizationService",
    OrganizationEvolution = "organizationEvolution",
    OrganizationEvolutionTrend = "organizationEvolutionTrend",
    OrganizationOpeningHours = "organizationOpeningHours",
    OrganizationInvoices = "organizationInvoices",
    OrganizationCreatives = "organizationCreatives",
    OrganizationPreferences = "organizationPreference",
    OrganizationFeatureFlags = "organizationFeatureFlag",

    PointsOfSales = "pointsOfSales",
    PointOfSales = "pointOfSales",
    PointOfSalesDetails = "pointOfSalesDetails",
    PointOfSalesSetup = "pointOfSalesSetup",
    PointsOfSalesSetup = "pointOfSalesSetup",
    PointsOfSalesSetupState = "pointOfSalesSetupState",
    PointOfSalesGroups = "pointOfSalesGroups",
    PointOfSalesGroup = "pointOfSalesGroup",
    Shops = "shops",
    Competition = "competition",
    PosChannels = "posChannels",
    PosCashierInfo = "posCashierInfo",
    ExternalPosRemotePoss = "externalPosRemotePoss",
    PosCredential = "posCredential",
    PosCredentials = "posCredentials",
    Offer = "offer",
    Offers = "offers",
    OfferManagement = "offerManagement",
    OfferSlots = "offerSlots",
    OfferSlotsDivision = "offerSlotsDivision",
    OfferSlotsAllOrga = "offerSlotsAllOrga",
    OfferSlotsNumber = "OfferSlotsNumber",
    OfferFiltersParameters = "offerFiltersParameters",
    Ranking = "ranking",
    OrganizationExternalPos = "organizationExternalPos",
    OrganizationUsers = "organizationUsers",
    Notifications = "notifications",
    SalesForceGetAccounts = "salesForceGetAccounts",
    SalesForceGetContacts = "salesForceGetContacts",
    SalesForceGetConnection = "salesForceGetConnection",
    SponsoredAd = "sponsoredAd",
    // TODO: update the query keys to have for both marketingAction a grunalar cache with single and plural query keys (it's the case for offer and offers)
    SponsoredAdManagement = "sponsoredAdManagement",
    SponsoredAdFiltersParameters = "sponsoredAdFiltersParameters",
    SponsoredAdSlotsAgenda = "SponsoredAdSlotsAgenda",
    SponsoredAdSlotsAgendaNumber = "SponsoredAdSlotsAgendaNumber",
    SponsoredAdSlotsPerformance = "SponsoredAdSlotsPerformance",
    SponsoredAdSlotsDetail = "SponsoredAdSlotsDetail",
    SponsoredAdSlotsSummary = "SponsoredAdSlotsSummary",
    SponsoredAdsCreate = "sponsoredAdsCreate",
    SponsoredAdSlots = "SponsoredAdSlots",
    SponsoredAdSlotsDivision = "SponsoredAdSlotsDivision",
    SponsoredAdSlotsDistribution = "SponsoredAdSlotsDistribution",
    Channels = "channels",
    OrganizationExternalPoss = "OrganizationExternalPoss",
    Monitoring = "Monitoring",
    Services = "services",
    AdminMonitoring = "AdminMonitoring",
    ServiceAndChannel = "ServiceAndChannel",
    ExternalPosChannel = "externalposchannel",
    TriggerSummaryAverage = "TriggerSummaryAverage",
    PosArea = "PosArea",
    AlreadyTargetedRemoteShop = "AlreadyTargetedRemoteShops",
    Cuisines = "Cuisines",
    ZeShopExternalPoss = "zeShopExternalPoss",
    ProductList = "ProductList",
    BudgetSummary = "BudgetSummary",
    ReferencesValues = "ReferencesValues",
    ReferencesValuesForPeakScenario = "ReferencesValuesForPeakScenario",
    UnseenBulkOperations = "UnseenBulkOperations",

    GenerateActivityReport = "generateActivityReport",
    RefreshMaterializedView = "refreshMaterializedView",
    getMarketingActionTemplate = "getMarketingActionTemplate",

    getSlotAdminDebug = "getSlotAdminDebug",
    FeatureFlags = "featureFlags",

    OrganizationKPI = "organizationKPI",
    MarketingActionOngoingOperations = "marketingActionOngoingOperations",
}

export type UseQueryStatus = "error" | "success" | "pending";
